/* eslint-disable react-hooks/exhaustive-deps */
import Form from "../../../../shared/forms/Form";
import Field from "../../../../shared/forms/Field";
import FieldTextArea from "../../../../shared/controls/fieldTextArea";
import {Dialog} from "primereact/dialog";
import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import useForm from "../../../../shared/forms/useForm";
import useApiSeguimientoMonitoreo from "../../../../api/operaciones/useApiSeguimientoMonitoreo";
import FieldDropDown from "../../../../shared/controls/fieldDropDown";
import {tipoIndicador} from "../SeguimentoConstantes";

const AtenderIncidenciaModal = ({viajeId, incidenciaActual, setIncidenciaActual, onChangeBitacora,envio}) => {

    const [submitted, setSubmitted] = useState(false);
    const api = useApiSeguimientoMonitoreo()

    const {
        values,
        onChange,
        onValidate,
        isValid,
        setValues
    } = useForm();

    useEffect(() => {
        if (incidenciaActual != null)
            setValues({comentarios: incidenciaActual.comentarios, razonId: incidenciaActual.razonId})
    }, [incidenciaActual]);


    const visibleComentarios = incidenciaActual != null

    const enviarComentarios = async () => {

        setSubmitted(true);

        if (!isValid)
            return;
        let updated = null; 
        if (envio){
              updated = await api.crearBitacora(viajeId, values)
        }else{
              updated = await api.atenderBitacora(viajeId, incidenciaActual.id, values)
        }

        setIncidenciaActual(null)
        onChangeBitacora({...incidenciaActual, ...updated})
    }

    const getVisibleRazon = () => {
        return incidenciaActual?.indicador === tipoIndicador.seguimiento ||
            incidenciaActual?.indicador === tipoIndicador.lastPosition;
    }

    const getSource = () => {
        if (incidenciaActual?.indicador === tipoIndicador.lastPosition) {
            return `incidenciasEdi/47`; // por default tomamos las de Penske Cliente Id = 47
        }

        return `general/OpcionSeguimiento`;
    }

    const renderFooterModal = () => {
        return (
            <>
                <div className="p-1">
                    <Button label={incidenciaActual?.atendido ? 'Actualizar' : `Registrar`} onClick={enviarComentarios}
                            type="button"/>
                </div>
            </>
        );
    };

    return (
        <Dialog header="Seguimiento Incidencia" visible={visibleComentarios} style={{width: '400px'}}
                onHide={() => setIncidenciaActual(null)}
                footer={renderFooterModal}
        >
            <Form columns={1} values={values} onChange={onChange} onValidate={onValidate} submitted={submitted}>
                <Field field={"razonId"} name='razon'
                       label={"Razón"}
                       render={FieldDropDown}
                       valueById={true}
                       source={getSource()}
                       required={true}
                       isVisible={getVisibleRazon}
                />
                <Field label={'Comentarios'} field={'comentarios'} render={FieldTextArea} rows={5} required={true}/>
            </Form>
        </Dialog>
    )
}
export default AtenderIncidenciaModal;